async function clearCart() {
  try {
    // Step 1: clear the current cart
 
    const updateResponse = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    });
    const updatedCart = await updateResponse.json();
    setTimeout(() => {
        openCartDrawer();
        sessionStorage.setItem('cartCleared', 'true');
    }, 50);

    console.log('Bundle items removed:', updatedCart);
    // Optionally, update the UI or reload the cart
    console.log('Cart cleared');
  } catch (error) {
    console.error('Error removing bundle items:', error);
    console.log('Failed to clear cart. Please try again.');
  }
}

async function openCartDrawer() {
    console.log("Starting openCartDrawer...");

    try {
        // Fetch cart data and sections
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        const sectionsUrl = `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count`;
        const sectionsResponse = await fetch(sectionsUrl);
        const sectionsData = await sectionsResponse.json();

        console.log("Cart data:", cartData);
        console.log("Sections data:", sectionsData);

        // Update cart count
        if (window.Alpine && window.Alpine.store("cart_count")) {
            window.Alpine.store("cart_count").count = cartData.item_count;
        }

        if (window.theme) {
        window.theme.cartItemCount = cartData.item_count;
        }

        // Open cart drawer first
        if (window.Alpine && window.Alpine.store("modals")) {
        // window.Alpine.store("modals").open("cart");

        // Wait for drawer to open, then update content
        setTimeout(() => {
            console.log("Updating cart drawer content...");

            // Update cart items
            if (sectionsData["cart-items"]) {
            const cartItemsContainer =
                document.querySelector("[data-cart-items]");
            if (cartItemsContainer) {
                const parser = new DOMParser();
                const newContent = parser.parseFromString(
                sectionsData["cart-items"],
                "text/html"
                );
                const newCartItems = newContent.querySelector("[data-cart-items]");

                if (newCartItems) {
                    cartItemsContainer.innerHTML = newCartItems.innerHTML;

                // Re-initialize Alpine.js on updated content
                if (window.Alpine) {
                    window.Alpine.initTree(cartItemsContainer);
                    window.Alpine.store('cart').isOpen = false;
                }
                
                console.log("Cart items updated");
                }
            }
            }

            // Update cart footer
            if (sectionsData["cart-footer"]) {
            const cartFooterContainer =
                document.querySelector("[data-cart-footer]");
            if (cartFooterContainer) {
                const parser = new DOMParser();
                const newContent = parser.parseFromString(
                sectionsData["cart-footer"],
                "text/html"
                );
                const newCartFooter =
                newContent.querySelector("[data-cart-footer]");

                if (newCartFooter) {
                cartFooterContainer.innerHTML = newCartFooter.innerHTML;

                // Re-initialize Alpine.js on updated content
                if (window.Alpine) {
                    window.Alpine.initTree(cartFooterContainer);
                    window.Alpine.store('cart').isOpen = false;
                }
                console.log("Cart footer updated");
                }
            }
            }
        }, 300); // Wait for drawer animation
        }
        console.log("Cart drawer opened successfully");
        return cartData;
    } catch (error) {
        console.error("Error in openCartDrawer:", error);

        // Fallback: simple cart open
        // if (window.Alpine && window.Alpine.store("modals")) {
        // window.Alpine.store("modals").open("cart");
        // } else {
        // Ultimate fallback - redirect to cart page
        // window.location.href = "/cart";
        // }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if(ShopifyAnalytics.meta.page.customerId){
        const interval = setInterval(() => {
                console.log('maaz',window.Alpine , window.Alpine.store('modals')?.rightDrawer?.contents === 'cart');
                if (window.Alpine && window.Alpine.store('modals')?.rightDrawer?.contents === 'cart') {
                    console.log("Closing cart drawer now");
                    Alpine.store('modals').close('cart');
                    clearInterval(interval);
                }
        },5); // 50ms is enough
        const cleared = sessionStorage.getItem('cartCleared');
        if (cleared) {
          
        }
        else{
          clearCart();
        }
    }
    else{
        sessionStorage.removeItem('cartCleared');
    }    
});
